import { render, staticRenderFns } from "./CompanyBase.vue?vue&type=template&id=77e4aa28&scoped=true&"
import script from "./CompanyBase.vue?vue&type=script&lang=js&"
export * from "./CompanyBase.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBase.vue?vue&type=style&index=0&id=77e4aa28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e4aa28",
  null
  
)

export default component.exports